import src from "IMAGE";
export default { src, width: 1438, height: 395, blurWidth: 0, blurHeight: 0};
